import { Controller } from "react-hook-form";
import { TextField } from "./Fields";

type props = {
  control: any;
  name: string;
  label: string;
  type:string;
  required?:boolean;
  [key:string]:any;
  className?: string;
};

//react-hook-form + TextFieldでバリデーションチェックを行う用のフォーム
const FormController = ({control,name,label,type,required,className="",...props}:props) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          {...props}
          type={type}
          label={label}
          required={required}
          error={fieldState.error}
          helperText={fieldState.error?.message}
          className={className}
        />
      )}
    />
  );
};

export default FormController
